import { get, post } from '@/utils/request'

const adminApi = {
  siteConfig: '/api/admin/account/site_config',
  getAccountApi: '/api/admin/account',
  getUserAvatarsApi: '/api/admin/user/user/avatar',
  getVipPlanApi: '/api/admin/user/vip_plan',
  fileStoreConfigApi: '/api/admin/file/file_store',
  getNotifyConfigApi: '/api/admin/message/notify/webhook',
  getAlbumsApi: '/api/admin/content/video/all',
  getArticlesApi: '/api/admin/content/video/all',
  getVideosApi: '/api/admin/content/vod/list'
}

export function getSiteConfigs() {
  return get(adminApi.siteConfig)
}

export function updateSiteConfig(payload) {
  return post(adminApi.siteConfig, payload)
}

export function getAccountList(queryParams) {
  return get(adminApi.getAccountApi + '/list', queryParams)
}

export function getAccountOnline(queryParams) {
  return get(adminApi.getAccountApi + '/online', queryParams)
}

export function getAccountSession(queryParams) {
  return get(adminApi.getAccountApi + '/session', queryParams)
}

export function getUserAvatarList() {
  return get(adminApi.getUserAvatarsApi)
}

export function getVideoList(queryParams) {
  return get(adminApi.getVideosApi, queryParams)
}

export function getAlbumList(nextId) {
  return get(adminApi.getAlbumsApi + '?nextId=' + nextId)
}

export function getArticleList(nextId) {
  return get(adminApi.getArticlesApi + '?nextId=' + nextId)
}

export function getFileStoreConfig() {
  return get(adminApi.fileStoreConfigApi)
}

export function addFileStoreConfig(payload) {
  return post(adminApi.fileStoreConfigApi, payload)
}

export function getNotifyConfig() {
  return get(adminApi.getNotifyConfigApi)
}

export function getVipPlan() {
  return get(adminApi.getVipPlanApi)
}
